<p class="text-center mt-4 mb-3">
  {{
    (isBlocking
      ? 'players.activePlayer.confirmationMessagePlayerBlocked'
      : 'players.activePlayer.confirmationMessagePlayerUnblocked'
    ) | translate
  }}
</p>

<div class="form-group px-4 mb-4">
  <label for="blockReason" class="form-label">
    {{
      (isBlocking
        ? 'players.activePlayer.blockReasonLabel'
        : 'players.activePlayer.unblockReasonLabel'
      ) | translate
    }}
    <span class="text-danger">*</span>
  </label>
  <textarea
    id="blockReason"
    class="form-control"
    rows="3"
    [(ngModel)]="reason"
    placeholder="{{
      (isBlocking
        ? 'players.activePlayer.blockReasonPlaceholder'
        : 'players.activePlayer.unblockReasonPlaceholder'
      ) | translate
    }}">
  </textarea>
  @if (!isReasonValid) {
    <small class="text-danger">{{ 'players.activePlayer.blockReasonRequired' | translate }}</small>
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-danger" (click)="closeModal()">
    {{ 'btn.cancel' | translate }}
  </button>
  <button
    type="button"
    class="btn btn-secondary"
    [disabled]="!isReasonValid || isSubmitting"
    [attr.aria-busy]="isSubmitting"
    (click)="blockPlayer()">
    @if (isSubmitting) {
      <i class="fa fa-spinner fa-spin me-1" aria-hidden="true"></i>
    }
    {{
      (isBlocking ? 'players.activePlayer.blockPlayer' : 'players.activePlayer.unblockPlayer')
        | translate
    }}
  </button>
</div>
